export function trackAssessmentCompleted(assessmentType: string) {
  window.gtag?.('event', 'assessment_completed', {
    event_category: 'engagement',
    event_label: assessmentType,
  });
}

export function trackFormSubmitted(formName: string) {
  window.gtag?.('event', 'form_submitted', {
    event_category: 'lead',
    event_label: formName,
  });
}

export function trackHubSpotMeetingClicked(source: string) {
  window.gtag?.('event', 'hubspot_meeting_clicked', {
    event_category: 'engagement',
    event_label: source,
  });
}

/** @deprecated Use trackHubSpotMeetingClicked. */
export const trackCalendlyClicked = trackHubSpotMeetingClicked;

export function trackPDFDownloaded(assessmentType: string) {
  window.gtag?.('event', 'pdf_downloaded', {
    event_category: 'engagement',
    event_label: assessmentType,
  });
}
